// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '@med/app/core/config/environment-config';

export const config: EnvironmentConfig = {
  smartLookIntegration: false,
  sentry: false,
  apiUrl: 'https://api.cosmose.cn',
  enterpriseApi: 'https://api.cosmose.cn/enterprise-api/v1',
  apiDspCampaignService: 'enterprise-dsp-api/v1',
  apiFacebookIntegrator: 'facebook-integrator/v2',
  apiStoreScan: 'store-scan-api/v4',
  securityToken: 'ZW50ZXJwcmlzZS13ZWI6VmFlaTNiaFhVbktlM1J1Vmx3R0I=',
  mapboxToken: 'pk.eyJ1IjoiY29zbW9zZSIsImEiOiJja2JtOGw4bTYxZ2hmMnhsczV0NnA5YjVvIn0.c_lanWto1ySJcmPXCmEx1Q',
  googleAnalytics: 'UA-101159088-3',
  hotjarClientId: 1750042,
  plannerDemoType: 'china',
  excludedLanguageUrlRegex: 'https://api.cosmose.cn/enterprise-api/v1/campaigns/\\d+/estimates',
  lockscreenApi: 'https://kaikai-now-content-api.dev.cosmose.cloud/kaikai-now-content-api/v1',
  toggles: {
    showAdvertiserFilter: false
  }
};
